module.exports = __webpack_public_path__ + "static/media/Northville-Green.f81592dc.pdf";